import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";
import { ProjectCard } from "@/components/shared/ProjectCard";
import { useProjects } from "@/hooks/useContent";

export function FeaturedProjects() {
  const { data: projects = [] } = useProjects();
  const list = projects.slice(0, 5);

  return (
    <section data-testid="projects-section" className="relative bg-light py-24 md:py-28">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <Eyebrow className="mb-6">PROJELER</Eyebrow>
            <Reveal>
              <h2 className="font-head font-extrabold text-ink tracking-tight text-4xl md:text-5xl lg:text-6xl max-w-2xl leading-[1.02]">
                Mühendisliği sahada gerçeğe dönüştürüyoruz.
              </h2>
              <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-ink/55">
                Aşağıdaki görseller ve başlıklar, hizmet alanlarımızı anlatan örnek proje senaryolarıdır; gerçek referans beyanı değildir.
              </p>
            </Reveal>
          </div>
          <Link to="/projeler" data-testid="all-projects-link" className="group inline-flex items-center gap-2 text-tech font-semibold shrink-0">
            ÖRNEK PROJELERİ GÖR
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {list.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            <div className="md:row-span-2">
              <ProjectCard project={list[0]} index={0} large />
            </div>
            {list.slice(1, 3).map((p, i) => (
              <ProjectCard key={p.slug} project={p} index={i + 1} />
            ))}
            {list.slice(3, 5).map((p, i) => (
              <ProjectCard key={p.slug} project={p} index={i + 3} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
